import httpClient from './httpClient'

const END_POINT = '/api/aulas'

const getAllAulas = () => httpClient.get(END_POINT, { params: { pagination: false } })

const findByNumeroAula = (numero) => httpClient.get(END_POINT, { params: { numero, pagination: false } })

export {

    getAllAulas,
    findByNumeroAula

}